const UI = {
  scrollY() {
    const theScrollY =
      window.scrollY ||
      window.pageYOffset ||
      document.body.scrollTop ||
      // @ts-ignore
      document.documentElement.scrollTop;
    return theScrollY;
  },

  offset(el: any, type?: string) {
    if (!el || typeof el.getBoundingClientRect !== 'function') {
      return 0;
    }

    const { left, top, width, height } = el.getBoundingClientRect();

    switch (type) {
      case 'top':
        return top + window.pageYOffset;

      case 'left':
        return left + window.pageXOffset;

      case 'height':
        return height;

      case 'width':
        return width;

      default:
        return {
          height,
          width,
          top: top + window.pageYOffset,
          left: left + window.pageXOffset,
        };
    }
  },
};

export default UI;
export const { scrollY, offset } = UI;
